import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 9l14 0","key":"svg-0"}],["path",{"d":"M5 15l14 0","key":"svg-1"}],["path",{"d":"M11 4l-4 16","key":"svg-2"}],["path",{"d":"M17 4l-4 16","key":"svg-3"}]]

/**
 * IconHash
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItaGFzaCIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNNSA5bDE0IDAiIC8+CiAgPHBhdGggZD0iTTUgMTVsMTQgMCIgLz4KICA8cGF0aCBkPSJNMTEgNGwtNCAxNiIgLz4KICA8cGF0aCBkPSJNMTcgNGwtNCAxNiIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/hash
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconHash = createReactComponent('outline', 'hash', 'Hash', __iconNode);

export default IconHash;